import { useCallback, useEffect, useState } from "react";
import FormField from "./FormField";
import apiCall from "../helper/apiCall";
import uploadImage from "../helper/uploadImage";
import ProductAttributes from "./ProductAttributes";

const ProductUploadVariantForm = ({ formData, onNext, onBack, allFormData }) => {
     const VPS_BASE_URL = "https://admin.kanthasri.com";
  // Initialize state with a fallback empty object for formData
  const [localData, setLocalData] = useState({});
  const [errors, setErrors] = useState({});
  const [variationTypes, setVariationTypes] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [colors, setColors] = useState([]);
  const [variantAvailable, setVariantAvailable] = useState([{ name: 'Yes', value: 'Y' }, { name: 'No', value: 'N' }]);
  // Initialize variantTableData with localData.variants or a default row, now including product_weight and product_image as arrays
  const [variantTableData, setVariantTableData] = useState([]);
  const [sizeAndColorId, setSizeAndColorId] = useState('');
  const [sizeId, setSizeId] = useState('');
  const [colorId, setColorId] = useState('');
  // State for the image preview modal
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false); // New state for loading indicator

  // This useEffect synchronizes the component's state with the props
  // It's crucial for ensuring data is retained when navigating back
  useEffect(() => {
    if (formData) {
      setLocalData(formData);
      setVariantTableData(formData.variants || [{ id: 1, size_id: '', color_id: '', mrp: '', selling_price: '', product_weight: '', product_images: [], imageUrls: [] }]);
    }
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalData((prevData) => {
      // If the user changes 'is_variant_available' to 'No', clear the variation type
      if (name === 'is_variant_available' && value === 'N') {
        // When switching to "No", we must also reset the table to a single default row
        setVariantTableData([{ id: 1, size_id: '', color_id: '', stock_qty: '', mrp: '', selling_price: '', product_weight: '', product_images: [], imageUrls: [] }]);
        return {
          ...prevData,
          [name]: value,
          product_variation_id: '',
        };
      } else if (name === 'is_variant_available' && value === 'Y') {
        // When switching to "Yes", reset to an empty table to force user input
        setVariantTableData([{ id: 1, size_id: '', color_id: '', stock_qty: '', mrp: '', selling_price: '', product_weight: '', product_images: [], imageUrls: [] }]);
      }
      return {
        ...prevData,
        [name]: value,
      };
    });
    // Clear the error for the changed field
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    }
  };

  const handleAttributesChange = useCallback((attributes) => {
    console.log('Selected Attributes in Parent:', attributes);
    let name = 'product_attributes';
    setLocalData((preve) => ({
      ...preve,
      [name]: attributes,
    }));
  }, [setLocalData]);

  const handleTableChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...variantTableData];
    list[index][name] = value;
    setVariantTableData(list);
    // Clear the error for the changed field
    if (errors[`row-${index}-${name}`]) {
      setErrors((prevErrors) => ({ ...prevErrors, [`row-${index}-${name}`]: '' }));
    }
  };

  // Function to handle multiple image uploads via Cloudinary API
//   const handleImageUpload = (index) => async (e) => {
//     setLoading(true);
//     const files = Array.from(e.target.files);

//     try {
//       if (files.length > 0) {
//         const file = files[0];
//         // Simulate the user's API call
//         const uploadImageAPI = await uploadImage(file);
//         console.log(uploadImageAPI);

//         const newList = [...variantTableData];
//         // Store the public URL from the API response
//         newList[index] = {
//           ...newList[index],
//           product_images: [...newList[index].product_images, uploadImageAPI.public_id], // You might store the public ID
//           imageUrls: [...newList[index].imageUrls, uploadImageAPI.url] // Store the URL for display
//         };
//         setVariantTableData(newList);
//       }

//       // Clear the error for the image field if an image is uploaded
//       if (files.length > 0 && errors[`row-${index}-product_images`]) {
//         setErrors((prevErrors) => ({ ...prevErrors, [`row-${index}-product_images`]: '' }));
//       }
//     } catch (error) {
//       console.error("Image upload failed:", error);
//     } finally {
//       setLoading(false);
//     }
//   };


const handleImageUpload = (index) => async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        setLoading(true);
        console.log('formData?.product_name:',localData?.product_name);
        const file = files[0];
        const formData = new FormData();
        const pName = allFormData?.general?.product_name || 'kanthasri-product';
        formData.append('name', pName);
        formData.append('image', file);

        try {
            const response = await fetch(`${VPS_BASE_URL}/admin/api/v1/image/upload`, {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();

            if (result.success) {
                const newList = [...variantTableData];
                // result.images contains { thumbnail, grid, main, zoom }
                const vpsImageObject = result.images;

                newList[index] = {
                    ...newList[index],
                    // We store the full object in product_images for the DB
                    product_images: [...newList[index].product_images, vpsImageObject],
                    // We store the path for the grid/preview version to show in the UI
                    imageUrls: [...newList[index].imageUrls, `${VPS_BASE_URL}${vpsImageObject.grid}`]
                };
                setVariantTableData(newList);
            } else {
                alert("Upload failed: " + (result.message || "Unknown error"));
            }
        } catch (error) {
            console.error("VPS Upload Error:", error);
            alert("Network error: Could not reach VPS.");
        } finally {
            setLoading(false);
            e.target.value = null; // Clear input
        }
    };
  // Function to remove a single image from the array
  const handleRemoveImage = (variantIndex, imageIndex) => {
    const newList = [...variantTableData];
    // Remove the image from the respective arrays
    const updatedImages = newList[variantIndex].product_images.filter((_, i) => i !== imageIndex);
    const updatedImageUrls = newList[variantIndex].imageUrls.filter((_, i) => i !== imageIndex);

    newList[variantIndex] = {
      ...newList[variantIndex],
      product_images: updatedImages,
      imageUrls: updatedImageUrls
    };
    setVariantTableData(newList);
  };

  // Function to show the image preview modal
  const handleImageClick = (imageUrl) => {
    setPreviewImage(imageUrl);
  };

  // Function to close the image preview modal
  const handleClosePreview = () => {
    setPreviewImage(null);
  };

  const handleAddRow = () => {
    const newId = variantTableData.length > 0 ? Math.max(...variantTableData.map(row => row.id)) + 1 : 1;
    // Add product_weight and product_images as an empty array to the new row
    setVariantTableData([...variantTableData, { id: newId, size_id: '', color_id: '', stock_qty: '', mrp: '', selling_price: '', product_weight: '', product_images: [], imageUrls: [] }]);
  };

  const handleDeleteRow = (index) => {
    const list = [...variantTableData];
    list.splice(index, 1);
    setVariantTableData(list);
  };

  const validate = () => {
    const newErrors = {};
    let formIsValid = true;
    const variationTypeId = localData.product_variation_id;

    // --- (Existing top-level form field validation remains the same) ---
    if (!localData.is_variant_available) {
        newErrors.is_variant_available = 'Variation is required.';
        formIsValid = false;
    } else if (localData.is_variant_available === 'Y') {
        if (!localData.product_variation_id) {
            newErrors.product_variation_id = 'Variation type is required.';
            formIsValid = false;
        }

        if (variantTableData.length === 0) {
            newErrors.variantTableData = 'At least one variant combination is required.';
            formIsValid = false;
        } else {
            // General validation for required fields
            variantTableData.forEach((row, index) => {
                const isSizeRequired = variationTypeId == sizeId || variationTypeId == sizeAndColorId;
                const isColorRequired = variationTypeId == colorId || variationTypeId == sizeAndColorId;

                if (isSizeRequired && !row.size_id) {
                    newErrors[`row-${index}-size_id`] = 'Size is required.';
                    formIsValid = false;
                }
                if (isColorRequired && !row.color_id) {
                    newErrors[`row-${index}-color_id`] = 'Color is required.';
                    formIsValid = false;
                }
                if (!row.stock_qty) {
                    newErrors[`row-${index}-stock_qty`] = 'Quantity is required.';
                    formIsValid = false;
                }
                if (!row.mrp) {
                    newErrors[`row-${index}-mrp`] = 'MRP is required.';
                    formIsValid = false;
                }
                if (!row.selling_price) {
                    newErrors[`row-${index}-selling_price`] = 'Selling price is required.';
                    formIsValid = false;
                }
                if (!row.product_weight) {
                    newErrors[`row-${index}-product_weight`] = 'Weight is required.';
                    formIsValid = false;
                }
                
                // ✅ NEW VALIDATION: MRP >= Selling Price
                if (row.mrp && row.selling_price && parseFloat(row.selling_price) > parseFloat(row.mrp)) {
                    newErrors[`row-${index}-selling_price`] = 'Selling price cannot be greater than MRP.';
                    formIsValid = false;
                }
            });

            // --- (Existing Uniqueness and Image Validation Logic remains the same) ---
            const seenSizes = new Set();
            const seenColors = new Set();
            const seenCombinations = new Set();

            variantTableData.forEach((row, index) => {
                if (variationTypeId == sizeId) {
                    if (seenSizes.has(row.size_id)) {
                        newErrors[`row-${index}-size_id`] = 'Size must be unique.';
                        formIsValid = false;
                    }
                    seenSizes.add(row.size_id);
                }

                if (variationTypeId == colorId) {
                    if (seenColors.has(row.color_id)) {
                        newErrors[`row-${index}-color_id`] = 'Color must be unique.';
                        formIsValid = false;
                    }
                    seenColors.add(row.color_id);

                    if (row.imageUrls.length === 0) {
                        newErrors[`row-${index}-product_images`] = 'An image is required for this color.';
                        formIsValid = false;
                    }
                }

                if (variationTypeId == sizeAndColorId) {
                    const combinationKey = `${row.size_id}-${row.color_id}`;
                    if (seenCombinations.has(combinationKey)) {
                        newErrors[`row-${index}-size_id`] = 'This size and color combination already exists.';
                        newErrors[`row-${index}-color_id`] = 'This size and color combination already exists.';
                        formIsValid = false;
                    }
                    seenCombinations.add(combinationKey);
                }
            });

            if (variationTypeId == sizeId) {
                const hasImage = variantTableData.some(row => row.imageUrls.length > 0);
                if (!hasImage) {
                    newErrors.product_images_size_variant = 'At least one image is required for the size variants.';
                    formIsValid = false;
                }
            } else if (variationTypeId == sizeAndColorId) {
                const colorsWithImages = new Set();
                const colorsWithoutImages = new Set();
                
                variantTableData.forEach(row => {
                    if (row.color_id) {
                        if (row.imageUrls && row.imageUrls.length > 0) {
                            colorsWithImages.add(row.color_id);
                        } else {
                            colorsWithoutImages.add(row.color_id);
                        }
                    }
                });
                
                const missingImageColors = [...colorsWithoutImages].filter(colorId => !colorsWithImages.has(colorId));
                
                if (missingImageColors.length > 0) {
                    formIsValid = false;
                    newErrors.product_images_color_variant = 'All selected colors must have at least one image uploaded for a variant.';
                }
            }
        }
    } else if (localData.is_variant_available === 'N') {
        // --- (Existing validation for "No" variant case) ---
        const row = variantTableData[0];
        if (!row.stock_qty) {
            newErrors[`row-0-stock_qty`] = 'Stock quantity is required.';
            formIsValid = false;
        }
        if (!row.mrp) {
            newErrors[`row-0-mrp`] = 'MRP is required.';
            formIsValid = false;
        }
        if (!row.selling_price) {
            newErrors[`row-0-selling_price`] = 'Selling price is required.';
            formIsValid = false;
        }
        if (parseFloat(row.selling_price) > parseFloat(row.mrp)) {
             newErrors[`row-0-selling_price`] = 'Selling price cannot be greater than MRP.';
             formIsValid = false;
        }
        if (row.imageUrls.length === 0) {
            newErrors[`row-0-product_images`] = 'At least one image is required.';
            formIsValid = false;
        }
    }

    setErrors(newErrors);
    return formIsValid;
};
  const handleNextClick = () => {
    if (validate()) {

       const processedVariants = [...variantTableData];
        const variationTypeId = localData.product_variation_id;

        // Process images based on the selected variation type
        if (variationTypeId == sizeId) { // Variation Type 1 (Size)
            // Find the first row that has images
            const firstRowWithImage = processedVariants.find(row => row.imageUrls.length > 0);

            if (firstRowWithImage) {
                const imagesToCopy = firstRowWithImage.product_images;
                const imageUrlsToCopy = firstRowWithImage.imageUrls;

                // Copy images to all other rows
                processedVariants.forEach(row => {
                    if (row.imageUrls.length === 0) {
                        row.product_images = imagesToCopy;
                        row.imageUrls = imageUrlsToCopy;
                    }
                });
            }
        } else if (variationTypeId == sizeAndColorId) { // Variation Type 3 (Size and Color)
            // Create a map to store images for each unique color
            const colorImageMap = new Map();
            processedVariants.forEach(row => {
                if (row.color_id && row.imageUrls.length > 0 && !colorImageMap.has(row.color_id)) {
                    colorImageMap.set(row.color_id, {
                        product_images: row.product_images,
                        imageUrls: row.imageUrls
                    });
                }
            });

            // Copy images to other variants of the same color
            processedVariants.forEach(row => {
                if (row.color_id && row.imageUrls.length === 0) {
                    const images = colorImageMap.get(row.color_id);
                    if (images) {
                        row.product_images = images.product_images;
                        row.imageUrls = images.imageUrls;
                    }
                }
            });
        }


      onNext({ ...localData, variants: variantTableData });
    }
  };

  const getVariationType = async () => {
    try {
      const result = await apiCall('getVariationType');
      setVariationTypes(result.data);
      const sizeAndColorType = result.data.find(el => el.variation_id == 3);
      const sizeType = result.data.find(el => el.variation_id == 1);
      const colorType = result.data.find(el => el.variation_id == 2);
      if (sizeAndColorType) {
        setSizeAndColorId(sizeAndColorType.variation_id);
      }
      if (sizeType) {
        setSizeId(sizeType.variation_id);
      }
      if (colorType) {
        setColorId(colorType.variation_id);
      }
    } catch (error) {
      console.error("Failed to fetch getVariationType:", error);
    }
  };

  const getSizes = async () => {
    try {
      const result = await apiCall('getSizes');
      setSizes(result.data);
    } catch (error) {
      console.error("Failed to fetch sizes:", error);
    }
  };

  const getColors = async () => {
    try {
      const result = await apiCall('getColors');
      setColors(result.data);
    } catch (error) {
      console.error("Failed to fetch colors:", error);
    }
  };

  // Initial data fetch for static lists
  useEffect(() => {
    getVariationType();
    getSizes();
    getColors();
  }, []);

  // Cleanup for image URLs on component unmount
  useEffect(() => {
    return () => {
      // In a real app, you wouldn't need to revokeObjectURL since you're using Cloudinary URLs.
      // This is a remnant of the old local file preview logic.
    };
  }, [variantTableData]);

  // Determine which columns to show based on the selected variation type
  const showSize = localData.product_variation_id == sizeId || localData.product_variation_id == sizeAndColorId;
  const showColor = localData.product_variation_id == colorId || localData.product_variation_id == sizeAndColorId;
  // Show table only if a variant option is selected
  const showTable = localData.is_variant_available;

  return (
    <div className="flex flex-col  font-sans antialiased bg-gray-50 min-h-screen p-1">
      <div className="bg-white rounded-lg shadow-lg p-1 mx-auto w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Variant Details</h2>
        <div className="grid grid-cols-1 mt-2">
          <label className="block text-sm font-medium text-gray-700" htmlFor='productAttributes'>Product additional attributes</label>
          <ProductAttributes onAttributesChange={handleAttributesChange} />

        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <FormField
            label="Product Variant"
            id="is_variant_available"
            type="select"
            value={localData.is_variant_available || ''}
            onChange={handleChange}
            required={true}
            errorMessage={errors.is_variant_available}
          >
            <option value="">Select...</option>
            {variantAvailable.map((el) => (
              <option key={el.value} value={el.value}>
                {el.name}
              </option>
            ))}
          </FormField>
          {localData.is_variant_available === 'Y' && (
            <FormField
              label="Choose variation type"
              id="product_variation_id"
              type="select"
              value={localData.product_variation_id || ''}
              onChange={handleChange}
              required={true}
              errorMessage={errors.product_variation_id}
            >
              <option value="">Select...</option>
              {variationTypes.map((el) => (
                <option key={el.variation_id} value={el.variation_id}>
                  {el.variation_name}
                </option>
              ))}
            </FormField>
          )}
        </div>

        {showTable && (
          <div className="mt-8 border border-gray-200 rounded-xl p-1 bg-gray-100 shadow-inner">
            <h3 className="font-semibold text-lg text-gray-700 mb-4">
              {localData.is_variant_available === 'Y' ? 'Variant Combinations' : 'Product Details'}
            </h3>
            {errors.variantTableData && <p className="mt-2 text-sm text-red-600 font-medium">{errors.variantTableData}</p>}
            {localData.product_variation_id == sizeId && errors.product_images_size_variant && (
              <p className="mt-2 text-sm text-red-600 font-medium text-center">
                {errors.product_images_size_variant}
              </p>
            )}
            {localData.product_variation_id == sizeAndColorId && errors.product_images_color_variant && (
              <p className="mt-2 text-sm text-red-600 font-medium text-center">
                {errors.product_images_color_variant}
              </p>
            )}
            <div className="overflow-x-auto rounded-lg shadow">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider rounded-tl-lg">S.No</th>
                    {showSize && (
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Size</th>
                    )}
                    {showColor && (
                      <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Color</th>
                    )}
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Quantity</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">MRP</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Selling Price</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Product Weight</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Images</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider rounded-tr-lg">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {variantTableData.map((row, index) => (
                    <tr key={row.id}>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                      {showSize && (
                        <td className="px-4 py-3 whitespace-nowrap">
                          <select
                            name="size_id"
                            value={row.size_id}
                            onChange={(e) => handleTableChange(e, index)}
                            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm p-1"
                          >
                            <option value="">Select Size</option>
                            {sizes.map((size) => (
                              <option key={size.size_id} value={size.size_id}>{size.size_name}</option>
                            ))}
                          </select>
                          {errors[`row-${index}-size_id`] && (
                            <p className="text-red-500 text-xs mt-1">{errors[`row-${index}-size_id`]}</p>
                          )}
                        </td>
                      )}
                      {showColor && (
                        <td className="px-4 py-3 whitespace-nowrap">
                          <select
                            name="color_id"
                            value={row.color_id}
                            onChange={(e) => handleTableChange(e, index)}
                            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm p-1"
                          >
                            <option value="">Select Color</option>
                            {colors.map((color) => (
                              <option key={color.color_id} value={color.color_id}>{color.color_name}</option>
                            ))}
                          </select>
                          {errors[`row-${index}-color_id`] && (
                            <p className="text-red-500 text-xs mt-1">{errors[`row-${index}-color_id`]}</p>
                          )}
                        </td>
                      )}
                      <td className="px-4 py-3 whitespace-nowrap">
                        <input
                          type="number"
                          name="stock_qty"
                          value={row.stock_qty}
                          onChange={(e) => handleTableChange(e, index)}
                          className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm p-1"
                          placeholder="Stock quantity"
                        />
                        {errors[`row-${index}-stock_qty`] && (
                          <p className="text-red-500 text-xs mt-1">{errors[`row-${index}-stock_qty`]}</p>
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <input
                          type="number"
                          name="mrp"
                          value={row.mrp}
                          onChange={(e) => handleTableChange(e, index)}
                          className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm p-1"
                          placeholder="MRP"
                        />
                        {errors[`row-${index}-mrp`] && (
                          <p className="text-red-500 text-xs mt-1">{errors[`row-${index}-mrp`]}</p>
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <input
                          type="number"
                          name="selling_price"
                          value={row.selling_price}
                          onChange={(e) => handleTableChange(e, index)}
                          className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm p-1"
                          placeholder="Selling Price"
                        />
                        {errors[`row-${index}-selling_price`] && (
                          <p className="text-red-500 text-xs mt-1">{errors[`row-${index}-selling_price`]}</p>
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <input
                          type="number"
                          name="product_weight"
                          value={row.product_weight}
                          onChange={(e) => handleTableChange(e, index)}
                          className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm p-1"
                          placeholder="Weight"
                        />
                        {errors[`row-${index}-product_weight`] && (
                          <p className="text-red-500 text-xs mt-1">{errors[`row-${index}-product_weight`]}</p>
                        )}
                      </td>
                      <td className='px-4 py-3'>
                        <div className="flex flex-wrap gap-2 mb-2">
                          {row.imageUrls.map((url, imageIndex) => (
                            <div key={imageIndex} className="relative">
                              <img
                                src={url}
                                alt={`product ${imageIndex}`}
                                className="w-12 h-12 rounded-lg object-cover border border-gray-300 cursor-pointer"
                                onClick={() => handleImageClick(url)}
                              />
                              <button
                                onClick={() => handleRemoveImage(index, imageIndex)}
                                className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 text-white rounded-full h-5 w-5 flex items-center justify-center text-xs font-bold"
                                aria-label="Remove image"
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </div>
                        <label htmlFor={`uploadImageInput${index}`}>
                          <div className='text-gray-500 cursor-pointer flex justify-center items-center flex-col gap-1 hover:text-blue-500 transition-colors'>
                            {loading ? (
                              <svg className="animate-spin h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.963l3-2.672z"></path>
                              </svg>
                            ) : (
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="h-6 w-6">
                                <path fill="currentColor" d="M288 152V64H112c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V288c0-14.1-10.4-26-24-29.4V192c0-10.9-5.1-21-13.9-27.6L314.9 133.5C307.3 128 297.4 128 288 131.5V152zm-32 56c0 14.1 10.4 26 24 29.4V368c0 10.9 5.1 21 13.9 27.6l64 48c10.3 7.7 23.3 12.4 37.1 12.4H416c8.8 0 16-7.2 16-16V288.7c-3.1 1.5-6.3 2.7-9.6 3.6l-50.5 14.4c-9.1 2.6-18.9-1.9-23.7-10.2l-64-112c-5-8.8-5-19.8 0-28.6l64-112c4.8-8.4 14.6-12.8 23.7-10.2l50.5 14.4c3.3.9 6.5 2.1 9.6 3.6V96c0-8.8-7.2-16-16-16H288c-10.6 0-21.5-3.8-29.6-10.4L224.2 46.8C216.7 40.2 208 36.9 199.1 36.9H160c-26.5 0-48 21.5-48 48v24c0 13.3 10.7 24 24 24s24-10.7 24-24V84.9c0-5 4.1-9.1 9.1-9.1H199.1c5 0 9.1 4.1 9.1 9.1v84.2c-15.6 15.6-24.2 36.4-24.2 58.9c0 22.5 8.6 43.3 24.2 58.9c-15.6 15.6-24.2 36.4-24.2 58.9c0 22.5 8.6 43.3 24.2 58.9v84.2c0 5 4.1 9.1 9.1 9.1h39.1c11.3 0 22.1-4.7 29.8-13.1l64-64c15.6-15.6 24.2-36.4 24.2-58.9c0-22.5-8.6-43.3-24.2-58.9c15.6-15.6 24.2-36.4 24.2-58.9c0-22.5-8.6-43.3-24.2-58.9V84.9c0-5-4.1-9.1-9.1-9.1h-39.1c-11.3 0-22.1 4.7-29.8 13.1L256 160c-15.6 15.6-24.2 36.4-24.2 58.9z" />
                              </svg>
                            )}
                            <p className='text-sm'>Upload images</p>
                          </div>
                          <input
                            onChange={handleImageUpload(index)}
                            type='file'
                            id={`uploadImageInput${index}`}
                            className='hidden'
                            accept="image/*"
                            multiple
                          />
                        </label>
                        {errors[`row-${index}-product_images`] && (
                          <p className="text-red-500 text-xs mt-1 text-center">{errors[`row-${index}-product_images`]}</p>
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
                        {localData.is_variant_available === 'Y' ? (
                          <button
                            onClick={() => handleDeleteRow(index)}
                            className="text-red-600 hover:text-red-900"
                            aria-label="Delete row"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                          </button>
                        ) : (
                          <span className="text-gray-400">N/A</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {localData.is_variant_available === 'Y' && (
              <div className="flex justify-end mt-6">
                <button
                  onClick={handleAddRow}
                  className="px-6 py-2 bg-green-500 text-white font-medium rounded-lg shadow-md hover:bg-green-600 transition-colors focus:outline-none focus:ring-2 focus:ring-green-400"
                >
                  Add Row
                </button>
              </div>
            )}
          </div>
        )}

        <div className="flex justify-between pt-8">
          <button
            onClick={onBack}
            className="px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg shadow-md hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Back
          </button>
          <button
            onClick={handleNextClick}
            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Next
          </button>
        </div>
      </div>

      {/* Image Preview Modal */}
      {previewImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75" onClick={handleClosePreview}>
          <div className="relative max-w-3xl max-h-full p-4 bg-white rounded-lg shadow-lg overflow-hidden" onClick={e => e.stopPropagation()}>
            <button
              onClick={handleClosePreview}
              className="absolute top-2 right-2 p-2 rounded-full text-white bg-gray-800 hover:bg-gray-900 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img src={previewImage} alt="Full size preview" className="w-full h-auto max-h-[80vh] object-contain" />
          </div>
        </div>
      )}
    </div>
  );
};
export default ProductUploadVariantForm;